export default {
	status: (state, getters) => {
		return getters.parts.length > 0 ? 'open' : 'closed'
	},
	parts: state => state.parts,
	cart: state => state.cart,
	cartProducts: state => state.cartProducts,
	loading: state => state.loading,
	fullParts: state => state.fullParts,
	sum: state =>
	{
		const rootParts = state.parts.filter(part => !state.parts.find(_part => part.nearestParentId === _part.partId))

		return rootParts.reduce((sum, part) => {
			return parseFloat(sum) + (parseFloat(part.price) * part.selectedQuantity)
		}, 0)
	}
}
